import { BooleanStore, DummyStore } from 'stores';

import { SmartLinks } from '../../shared/types';

export const smartLinksStore = new DummyStore<SmartLinks>();
export const smartLinksFiltersStore = new DummyStore<FiltersType>();
export const copiedLinkStore = new DummyStore<string>('');
export const hasOrganizerLinksStore = new BooleanStore(false);
